export function getCurrentDate() {
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, "0"); // Adding 1 because getMonth() returns zero-based month index
    const day = String(currentDate.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
}
/**
 * Get the Date in the format specified
 * @param {*} format
 * @param {*} date
 * @returns date in the format DD/MM/YYYY
 */ export default function formatDate(date) {
    // Function to parse date string and create a local date
    const parseDateString = (dateString)=>{
        const [year, month, day] = dateString.split("-").map(Number);
        return new Date(year, month - 1, day); // Month is zero-based
    };
    const formattedDate = date ? parseDateString(date).toLocaleDateString(undefined, {
        year: "numeric",
        month: "2-digit",
        day: "2-digit"
    }) : new Date().toLocaleDateString(undefined, {
        year: "numeric",
        month: "2-digit",
        day: "2-digit"
    });
    return formattedDate;
}
